import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-text.png'

const TextBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default TextBtn
